import classNames from "classnames";
import React, { PropsWithChildren, useCallback, useState } from "react";
import { ListItem } from "../list";

const FeatureListItemColumn = ({
	children,
	fullWidth,
}: PropsWithChildren<{
	fullWidth?: boolean;
}>) => (
	<div
		className={classNames([
			"feature-list-item__column",
			{
				"feature-list-item__column--fullwidth": fullWidth,
			},
		])}
	>
		{children}
	</div>
);
FeatureListItemColumn.displayName = "FeatureListItemColumn";

export const FeatureListItem = <T extends string>({
	debug,
	featureKey,
	value,
	onSave,
}: {
	debug?: boolean;
	featureKey: T;
	value: string;
	onSave: (key: T, value: string) => void;
}) => {
	const [featureValue, setFeatureValue] = useState(value);

	const handleOnSaveClick = useCallback(() => {
		onSave(featureKey, featureValue);
	}, [featureValue, onSave, featureKey]);

	const isBoolean = value === "true" || value === "false";

	const inputJsx = isBoolean ? (
		<input
			type="checkbox"
			checked={featureValue === "true"}
			onChange={(e) => {
				const newValue = e.currentTarget.checked ? "true" : "false";

				onSave(featureKey, newValue);

				setFeatureValue(newValue);
			}}
		/>
	) : (
		<input
			type="text"
			value={featureValue}
			onChange={(e) => setFeatureValue(e.currentTarget.value)}
		/>
	);

	const cssClasses = classNames("feature-list-item", {
		"feature-list-item--debug": debug,
	});

	return (
		<ListItem className={cssClasses}>
			<FeatureListItemColumn fullWidth={!isBoolean}>{featureKey}</FeatureListItemColumn>
			<FeatureListItemColumn>{inputJsx}</FeatureListItemColumn>
			{!isBoolean ? (
				<FeatureListItemColumn>
					<input type="button" value="Save" onClick={handleOnSaveClick} />
				</FeatureListItemColumn>
			) : null}
		</ListItem>
	);
};
